import React from 'react';
import { Shield, Clock, FileCheck, Target } from 'lucide-react';
import { benefitsData } from '../../data/mock';

const BenefitsSection = () => {
  const iconComponents = {
    Shield: Shield,
    Clock: Clock,
    FileCheck: FileCheck,
    Target: Target
  };

  const iconColors = [
    'from-amber-500 to-amber-600',
    'from-stone-500 to-stone-600',
    'from-amber-600 to-amber-700',
    'from-stone-600 to-stone-700'
  ];

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-amber-50 text-amber-700 text-sm font-medium rounded-full mb-4">
            Benefícios
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-4">
            {benefitsData.title}
          </h2>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefitsData.benefits.map((benefit, index) => {
            const Icon = iconComponents[benefit.icon];
            return (
              <div
                key={index}
                className="group bg-white rounded-2xl p-6 border border-stone-200 hover:border-transparent hover:shadow-xl transition-all duration-300 text-center"
              >
                {/* Icon */}
                <div className={`inline-flex w-14 h-14 bg-gradient-to-br ${iconColors[index]} rounded-2xl items-center justify-center mb-5 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>

                {/* Content */}
                <h3 className="text-lg font-bold text-slate-800 mb-2">
                  {benefit.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
